{
  "decrease": "{fieldLabel} 감소",
  "increase": "{fieldLabel} 증가",
  "numberField": "번호 필드"
}
